import { render } from "./CredencialExpositorSection.vue?vue&type=template&id=3cc4b01d&ts=true"
import script from "./CredencialExpositorSection.vue?vue&type=script&lang=ts"
export * from "./CredencialExpositorSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__